import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DesignerComponent } from "./designer/designer.component";
import { PageNotFoundComponent } from "./shared/page-not-found/page-not-found.component";
import { TrackOrderComponent } from "./shared/track-order/track-order.component";
import { WishlistPageComponent } from "./shared/wishlist-page/wishlist-page.component";
import { CheckoutPageComponent } from "./dashboard/checkout-page/checkout-page.component";
import { OrderSuccessComponent } from "./order-success/order-success.component";
import { HomePageComponent } from "./dashboard/home-page/home-page.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { CartPageComponent } from "./dashboard/cart-page/cart-page.component";
import { ProductDetailPageComponent } from "./product-detail-page/product-detail-page.component";
import { UserDetailsComponent } from "./user-details/user-details.component";
import { ProfileComponent } from "./profile/profile.component";
import { PaymentComponent } from "./payment/payment.component";
import { PrivacyPageComponent } from "./shared/footer/privacy-page/privacy-page.component";
import { TermConditionComponent } from "./shared/footer/term-condition/term-condition.component";
import { ContactComponent } from "./contact/contact.component";
import { AdminOrderPageComponent } from "./admin/admin-order-page/admin-order-page.component";
import { NoAccessComponent } from "./admin/no-access/no-access.component";
import { MyStructuresComponent } from "./my-structures/my-structures.component";
import { UserNotificationComponent } from "./user-notification/user-notification.component";
import { RewardsComponent } from "./rewards/rewards.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { ProductViewlistComponent } from "./shared/product-viewlist/product-viewlist.component";
import { OverviewComponent } from "./profile/overview/overview.component";
import { AddressDetailsComponent } from "./profile/address-details/address-details.component";
import { ProfileDetailComponent } from "./profile/profile-details/profile-details.component";
import { UserReviewPageComponent } from "./profile/user-review-page/user-review-page.component";
import { RatingAndReviewComponent } from "./order-details/rating-and-review/rating-and-review.component";
import { ReviewSuccessComponent } from "./profile/review-success/review-success.component";
import { ItemListComponent } from "./profile/item-list/item-list.component";
import { ReturnReplacePageComponent } from "./profile/return-replace-page/return-replace-page.component";
import { OrderStatusComponent } from "./profile/order-status/order-status.component";
import { OrderInfoComponent } from "./profile/order-info/order-info.component";
import { AddressListComponent } from "./dashboard/checkout-page/address-list/address-list.component";
import { AddressFormComponent } from "./dashboard/checkout-page/address-form/address-form.component";
import { ProductReviewPageComponent } from "./product-detail-page/product-review-page/product-review-page.component";
import { OrderActionGuard } from "./core/guards/order-action.guard";

const routes: Routes = [
    {
        path: "admin",
        loadChildren: () => import("./admin/admin.module").then((m) => m.AdminModule),
    },
    {
        path: "designer",
        component: DesignerComponent,
        data: { noHeader: true, noBackButton: true },
    },
    {
        path: "designer/:id",
        component: DesignerComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "products/:id",
        component: ProductDetailPageComponent,
    },
    {
        path: "products/:id/reviews",
        component: ProductReviewPageComponent,
    },
    {
        path: "products",
        component: ProductViewlistComponent,
        data: { noHeader: true, noBackButton: true },
    },
    {
        path: "dashboard",
        component: DashboardComponent,
    },
    {
        path: "home",
        component: HomePageComponent,
        data: { noBackButton: true },
    },
    {
        path: "userDetails",
        component: UserDetailsComponent,
        data: { noHeader: true, noBackButton: true },
        canActivate: [AuthGuard],
    },
    {
        path: "account",
        component: ProfileComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: "trackOrder",
                component: TrackOrderComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "overview",
                component: OverviewComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "rewards",
                component: RewardsComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "addressDetails",
                component: AddressDetailsComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "profileDetails",
                component: ProfileDetailComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "orders/:id/itemsReview/:itemId/review",
                component: RatingAndReviewComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "orders/reviewSucccess/:id",
                component: ReviewSuccessComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "orders/:orderId/itemsReview",
                component: UserReviewPageComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "orders/:id/track",
                component: OrderStatusComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "orders/:id/orderInfo",
                component: OrderInfoComponent,
                canActivate: [AuthGuard],
            },
            {
                path: "orders/:id/:action",
                component: ItemListComponent,
                canActivate: [AuthGuard, OrderActionGuard],
            },
            {
                path: "orders/:id/:action/reason",
                component: ReturnReplacePageComponent,
                canActivate: [AuthGuard],
            },

            {
                path: "myStructures",
                component: MyStructuresComponent,
                canActivate: [AuthGuard],
            },
        ],
    },
    // {
    //     path: "login",
    //     component: LoginPageComponent,
    //     canActivate: [noAuthGuard],
    //     data: { noBackButton: true },
    // },
    {
        path: "wishlist",
        component: WishlistPageComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "checkout",
        component: CheckoutPageComponent,
        children: [
            { path: "", redirectTo: "cart", pathMatch: "full" },
            {
                path: "cart",
                component: CartPageComponent,
            },
            {
                path: "address",
                component: AddressListComponent,
            },
            {
                path: "addAddress",
                component: AddressFormComponent,
            },
            {
                path: "editAddress/:id",
                component: AddressFormComponent,
            },
        ],
    },
    {
        path: "payment",
        component: PaymentComponent,
        data: { noHeader: true },
    },
    {
        path: "order/success",
        component: OrderSuccessComponent,
    },
    {
        path: "order/success/:merchantTransactionId",
        component: OrderSuccessComponent,
    },
    {
        path: "adminOrderStatusHistory/:id",
        component: AdminOrderPageComponent,
    },
    {
        path: "noAccess",
        component: NoAccessComponent,
    },
    {
        path: "contact",
        component: ContactComponent,
    },
    {
        path: "",
        redirectTo: "/home",
        pathMatch: "full",
    },
    {
        path: "notifications",
        component: UserNotificationComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "terms-and-conditions",
        component: TermConditionComponent,
    },
    {
        path: "privacy-policy",
        component: PrivacyPageComponent,
    },
    {
        path: "page-not-found",
        component: PageNotFoundComponent,
    },
    {
        path: "**",
        redirectTo: "/page-not-found",
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
